import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Typography, Grid } from '@mui/material';

class OfferDecisionFinancedAssetsSummary extends React.PureComponent {
  render() {
    const { t, financedAssets } = this.props;
    return (
      <React.Fragment>
        <Typography variant='h6'>{t('OfferEdit.Decision.FinancedAssets.Title')}</Typography>
        {financedAssets.map(asset => {
          return (
            <Grid container spacing={1} key={asset.financedAssetId}>
              <Grid item xs={12} sm={4} md={4} key={asset.approvalLevelId}>
                {t('OfferEdit.Decision.FinancedAssets.AssetType')} : <span>{asset.assetTypeName}</span>
              </Grid>
              <Grid item xs={12} sm={4} md={4} key={asset.approvalLevelId}>
                {t('OfferEdit.Decision.FinancedAssets.AssetDescription')} :<span>{asset.assetDescription}</span>
              </Grid>
              <Grid item xs={12} sm={4} md={4} key={asset.approvalLevelId}>
                {t('OfferEdit.Decision.FinancedAssets.PriceWithVat')} :{' '}
                <span>{t('DECIMAL', { number: asset.acquisitionPriceWithVat }) + ' ' + (asset.currencyCode || '')}</span>
              </Grid>
            </Grid>
          );
        })}
      </React.Fragment>
    );
  }
}
OfferDecisionFinancedAssetsSummary.propTypes = {
  t: PropTypes.func.isRequired,
  financedAssets: PropTypes.array
};
export default withTranslation()(OfferDecisionFinancedAssetsSummary);
